<template>
  <div>
    <a-row :gutter="10">
      <a-col :md="6" :sm="24">
        <a-card :bordered="false" title="知识类型" style="min-height: calc(100vh - 140px)">
          <a slot="extra" href="#" @click="handleTypeAdd">新增</a>
          <a-input-search
            placeholder="请输入要搜索的内容"
            enter-button="搜索"
            @search="onSearch"
          />
          <a-tree
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            @select="onTreeSelect"
            :tree-data="treeData"
            class="knowledge-type-tree"
            @expand="onExpand"
          >
            <template slot="title" slot-scope="{ title, key, children }">
              <div class="tree-title">
                <div>
                  <span v-if="title.indexOf(searchValue) > -1">
                    {{ title.substr(0, title.indexOf(searchValue)) }}
                    <span style="color: #f50">{{ searchValue }}</span>
                    {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
                  </span>
                  <span v-else>{{ title }}</span>
                </div>
                <div class="hover-btn">
                  <a-tooltip title="添加子类型">
                    <a-icon type="plus-circle" theme="twoTone" :style="{ fontSize: '16px' }"
                            @click.stop="handleTypeAdd(key)"/>
                  </a-tooltip>
                  <a-tooltip title="编辑">
                    <a-icon type="edit" theme="twoTone" :style="{ fontSize: '16px' }" title="编辑"
                            @click.stop="handleTypeEdit(key)"/>
                  </a-tooltip>
                  <a-tooltip title="删除" v-if="children.length===0">
                    <a-icon type="delete" theme="twoTone" v-if="children.length===0"
                            :style="{ fontSize: '16px', color: '#FF0'}" title="删除"
                            @click.stop="handleTypeDelete(key, title)"/>
                  </a-tooltip>

                </div>
              </div>
            </template>
          </a-tree>
        </a-card>
      </a-col>
      <a-col :md="18" :sm="24">
        <a-card :bordered="false" :title="currentTypeName" style="min-height: calc(100vh - 140px)">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="文件名">
                    <j-input placeholder="请输入文件名" v-model="queryParam.name" allowClear></j-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
                </a-col>

              </a-row>
            </a-form>
          </div>
          <!-- 查询区域-END -->

          <!-- 操作按钮区域 -->
          <div class="table-operator" v-if="currentTypeId">
            <a-button @click="handleFileAdd" type="primary" icon="plus">新增</a-button>
            <a-dropdown v-if="selectedRowKeys.length > 0">
              <a-menu slot="overlay">
                <a-menu-item key="1" @click="batchDel">
                  <a-icon type="delete"/>
                  删除
                </a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px"> 批量操作
                <a-icon type="down"/>
              </a-button>
            </a-dropdown>
          </div>

          <!-- table区域-begin -->
          <div>
            <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
              <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a
              style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
              <a style="margin-left: 24px" @click="onClearSelected">清空</a>
            </div>

            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"

              @change="handleTableChange">
              <template slot="isShow" slot-scope="text, record">
                <a-switch default-checked @change="isShowChange(record)" v-model="record.isShow"/>
              </template>

              <template slot="htmlSlot" slot-scope="text">
                <div v-html="text"></div>
              </template>
              <template slot="imgSlot" slot-scope="text">
                <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
                <img v-else :src="getImgView(text)" height="25px" alt="图片不存在"
                     style="max-width:80px;font-size: 12px;font-style: italic;"/>
              </template>
              <template slot="fileSlot" slot-scope="text">
                <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
                <a-button
                  v-else
                  :ghost="true"
                  type="primary"
                  icon="download"
                  size="small"
                  @click="uploadFile(text)">
                  下载
                </a-button>
              </template>

              <span slot="action" slot-scope="text, record">
                <a @click="handleView(record)">查看</a>
                <a-divider type="vertical"/>
                <a @click="handleDownload(record)">下载</a>
                <a-divider type="vertical"/>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>

              </span>

            </a-table>
          </div>

          <busKnowledgeFile-modal ref="modalForm" @ok="modalFormOk"></busKnowledgeFile-modal>
          <BusKnowledgeTypeModal ref="typeModalForm" @ok="getTreeData"></BusKnowledgeTypeModal>
        </a-card>
      </a-col>
    </a-row>
  </div>


</template>

<script>

import {JeecgListMixin} from '@/mixins/JeecgListMixin'
import BusKnowledgeFileModal from './modules/BusKnowledgeFileModal'
import BusKnowledgeTypeModal from './modules/BusKnowledgeTypeModal'
import {deleteAction, getAction, postAction} from "@api/manage";
import {Base64} from 'js-base64'
import JInput from "@comp/jeecg/JInput";

export default {
  name: "BusKnowledgeFileList",
  mixins: [JeecgListMixin],
  components: {
    BusKnowledgeFileModal, BusKnowledgeTypeModal, JInput
  },
  data() {
    return {
      description: '知识库附件表管理页面',
      queryParam: {
        knowledgeType: 0
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '知识库类型',
          align: "center",
          dataIndex: 'knowledgeType_dictText'
        },
        {
          title: '附件路径',
          align: "center",
          width: 300,
          ellipsis: true,
          dataIndex: 'url'
        },
        {
          title: '文件名',
          align: "center",
          dataIndex: 'name'
        },
        {
          title: '大小',
          align: "center",
          dataIndex: 'size',
          customRender: this.fileSizeFormatter
        },
        {
          title: '下载次数',
          align: "center",
          width: 50,
          dataIndex: 'downloadCount'
        },
        {
          title: '查看次数',
          align: "center",
          width: 50,
          dataIndex: 'viewCount'
        },
        {
          title: '是否显示',
          align: "center",
          dataIndex: 'isShow',
          scopedSlots: {customRender: 'isShow'}
        },
        {
          title: '文件类型',
          align: "center",
          dataIndex: 'fileType',
          width: 120,
          ellipsis: true,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          width: 140,
          scopedSlots: {customRender: 'action'}
        }
      ],
      url: {
        list: "/knowledge.file/busKnowledgeFile/list",
        delete: "/knowledge.file/busKnowledgeFile/delete",
        typeDelete: '/knowledge.type/busKnowledgeType/delete',
        typeList: "/knowledge.type/busKnowledgeType/listAll",
        deleteBatch: "/knowledge.file/busKnowledgeFile/deleteBatch",
        isShowChange: "/knowledge.file/busKnowledgeFile/isShowChange",
        exportXlsUrl: "/knowledge.file/busKnowledgeFile/exportXls",
        importExcelUrl: "knowledge.file/busKnowledgeFile/importExcel",
      },
      dictOptions: {},
      treeData: [],
      allTypeData: [],
      expandedKeys: [],
      autoExpandParent: true,
      searchValue: '',
      currentTypeName: '未选择类型',
      currentTypeId: ''
    }
  },
  mounted() {
    this.queryParam.knowledgeType = 0
    this.getTreeData()
  },
  created() {
    if (!this.disableMixinCreated) {
      console.log(' -- mixin created -- ')
      this.queryParam.knowledgeType = 0
      this.loadData()
      //初始化字典配置 在自己页面定义
      this.initDictConfig()
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    initDictConfig() {
    },
    getTreeData() {
      getAction(this.url.typeList, {}).then((res) => {
        let allData = res.result
        this.allTypeData = allData
        this.treeData = this.listToTree('0', allData)
      })
    },
    listToTree(pid, list) {
      let treeData = []
      list.forEach((item) => {
        if (item.pid === pid) {
          let children = this.listToTree(item.id, list)
          treeData.push({
            title: item.name,
            key: item.id,
            children: children
          });
        }
      })
      return treeData
    },
    getParentKey(key, tree) {
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key;
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    handleFileAdd: function () {
      this.$refs.modalForm.add(this.currentTypeId, this.currentTypeName)
      this.$refs.modalForm.title = '新增'
      this.$refs.modalForm.disableSubmit = false
    },
    handleTypeAdd(key) {
      this.$refs.typeModalForm.add(key);
    },
    handleTypeEdit(key) {
      this.$refs.typeModalForm.edit(key);
    },
    handleTypeDelete(key, title) {
      this.$confirm({
        title: '提示',
        content: `是否删除'${title}'?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          deleteAction(this.url.typeDelete, {id: key}).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.getTreeData()
            } else {
              this.$message.warning(res.message)
            }
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    onTreeSelect(keys, e) {
      if (e.selected) {
        this.currentTypeName = e.node.dataRef.title
        this.currentTypeId = keys[0]
        this.queryParam.knowledgeType = this.currentTypeId
      } else {
        this.currentTypeName = '未选择类型'
        this.currentTypeId = ''
        this.queryParam.knowledgeType = 0
      }
      this.loadData()
    },
    onSearch(value) {
      const expandedKeys = this.allTypeData
        .map(item => {
          if (item.name.indexOf(value) > -1) {
            return this.getParentKey(item.id, this.treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i)
      console.log('expandedKeys=====>', expandedKeys)
      this.expandedKeys = expandedKeys
      this.autoExpandParent = true
      this.searchValue = value
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    fileSizeFormatter(t, r, i) {
      if (t == 0) {
        return '0 Bytes'
      }
      const fileSize = t
      const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const srcSize = parseFloat(fileSize)
      const index = Math.floor(Math.log(srcSize) / Math.log(1024))
      const size = srcSize / Math.pow(1024, index)
      const sizeStr = size.toFixed(2) //保留的小数位数
      return sizeStr + ' ' + unitArr[index]
    },
    handleView(record) {
      window.open(
        `https://gis.canc.com.cn:9443/kkpreview/onlinePreview?url=${encodeURIComponent(Base64.encode(record.url))}`
      )
    },
    handleDownload(record) {
      window.open(record.url)
    },
    async isShowChange(record) {
      let res = await postAction(this.url.isShowChange, {id: record.id, isShow: record.isShow})
      if (res.success) {
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.knowledge-type-tree {
  .ant-tree-treenode-switcher-close, .ant-tree-treenode-switcher-open {
    display: flex;
    flex-wrap: wrap;

    .ant-tree-child-tree {
      width: 100%;
    }

    .ant-tree-node-content-wrapper {
      flex: 1;

      .tree-title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .anticon {
          margin-left: 10px;
        }

        .hover-btn {
          display: none;
        }

        &:hover {
          .hover-btn {
            display: block;
          }
        }
      }
    }
  }

}

</style>